export enum CALILIO_NODE_ENV {
  LOCAL = 'local',
  DEVELOP = 'develop',
  STAGING = 'staging',
  UAT = 'uat',
  PRODUCTION = 'production',
}
